<template>
  <div>
    <b-modal
      ref="exportConfirm"
      centered
      :title="$t('btn.basic.export')"
      size="lg"
      :ok-title="$t('btn.basic.export')"
      :cancel-title="$t('lbl.basic.cancel')"
      @ok="confirmExport(entity)"
    >
      <div class="form-horizontal">
        <div class="row">
          <div class="col-xs-2">
            {{$t('export.totalRows')}}<input type="text" class="form-control" v-model="totalRows" disabled="true"/>
          </div>&emsp;&emsp;&emsp;
          <div class="col-xs-2">
            {{$t('export.totalDown')}}<input type="text" class="form-control" v-model="paramList[0].value" :placeholder=totalRows />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    entity: {
      type: String
    },
    config: {
      type: Object
    }
  },
  data() {
    return {
      totalRows: 0,
      paramList: [
        { label: "export.perPageSize", value: '' }
      ]
    };
  },
  computed: {
    paramValue() {
      return name => this.paramList.filter(v => v.label === name)[0];
    }
  },
  watch: {
    config(newValue) {
      this.totalRows = newValue.totalRows <= 0 ? 0 : newValue.totalRows;
    }
  },
  methods: {
    recoverInitData() {
      const paramValue = this.paramValue;
      paramValue("export.perPageSize").value = '';
    },
    show() {
      this.recoverInitData();
      this.$refs.exportConfirm.show();
    },
    confirmExport(entity) {
      const paramValue = this.paramValue;
      const totalReg = this.totalRows;

      const currentPage = 0;
      const numRegPag = (paramValue("export.perPageSize").value || totalReg);

      this.MMFExport({
        entity,
        exportParam: {
          currentPage,
          numRegPag,
          totalReg
        }
      });
    },
    ...mapActions("base", ["MMFExport"])
  }
};
</script>
